// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle-" + chunkId + "-" + {"vendors-node_modules_html2canvas_dist_html2canvas_js":"a920f0f53516b11f777f","vendors-node_modules_dompurify_dist_purify_js":"3304a884b15624cad22c","vendors-node_modules_canvg_lib_index_es_js":"25d630200203ba606b37"}[chunkId] + ".js";
};